/**
 * Bilingual copy for the Portfolios page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  pageTitle: 'Industries We Serve',
  clientsTitle: 'Our Clients',
  clientLogoAlt: 'Client logo',
  sectors: [
    'Banking & Finance',
    'Retail & E-commerce',
    'Manufacturing',
    'Healthcare',
    'Hospitality',
    'Education',
    'Insurance',
    'Government',
    'Telecommunications',
    'Agriculture',
  ],
  portfolios: [
    {
      title: 'ABC Bank',
      category: 'Banking',
      description:
        "Implemented a comprehensive HRMS and CRM solution for one of Cambodia's leading banks, streamlining operations across 25 branches and improving customer service efficiency by 40%.",
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'XYZ Retail Group',
      category: 'Retail',
      description:
        'Deployed our integrated inventory and accounting modules, helping this retail chain manage stock across 12 locations while providing real-time financial insights to management.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Golden Insurance',
      category: 'Insurance',
      description:
        'Provided a tailored insurance management solution that reduced policy processing time by 60% and improved customer satisfaction scores by 35% within the first six months.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Sunrise Hotels',
      category: 'Hospitality',
      description:
        'Implemented our HRMS system to manage staff across 5 hotel properties, optimizing scheduling and reducing administrative overhead by 30%.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Cambodia Manufacturing Co.',
      category: 'Manufacturing',
      description:
        'Deployed our complete business suite to integrate production planning, inventory management, and financial operations, resulting in a 25% increase in operational efficiency.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Green Agriculture',
      category: 'Agriculture',
      description:
        'Implemented a customized inventory and operations management system for this agricultural supplier, helping them track produce from farm to consumer.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
  ],
  cta: {
    title: 'Ready to become our next success story?',
    body: 'Contact us today to discuss how AKAS solutions can transform your business operations.',
    button: 'Contact Us',
  },
};

export type Copy = typeof en;

export const km: Copy = {
  pageTitle: 'វិស័យដែលយើងបម្រើ',
  clientsTitle: 'អតិថិជនរបស់យើង',
  clientLogoAlt: 'ឡូហ្គោអតិថិជន',
  sectors: [
    'ធនាគារ និងហិរញ្ញវត្ថុ',
    'ការលក់រាយ និងពាណិជ្ជកម្មអនឡាញ',
    'ផលិតកម្ម',
    'សុខាភិបាល',
    'សណ្ឋាគារ',
    'អប់រំ',
    'ធានារ៉ាប់រង',
    'រដ្ឋាភិបាល',
    'ទូរគមនាគមន៍',
    'កសិកម្ម',
  ],
  portfolios: [
    {
      title: 'ABC Bank',
      category: 'ធនាគារ',
      description:
        'បានអនុវត្តដំណោះស្រាយ HRMS និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជនពេញលេញសម្រាប់ធនាគារឈានមុខគេមួយនៅកម្ពុជា ធ្វើឱ្យប្រតិបត្តិការរលូននៅសាខាទាំង ២៥ ហើយបង្កើនប្រសិទ្ធភាពសេវាកម្មអតិថិជន ៤០%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'XYZ Retail Group',
      category: 'ការលក់រាយ',
      description:
        'បានដាក់ឱ្យប្រើម៉ូឌុលស្តុក និងគណនេយ្យរួមបញ្ចូលរបស់យើង ដើម្បីជួយបណ្តាញហាងលក់រាយនេះគ្រប់គ្រងស្តុកនៅទីតាំងទាំង ១២ ហើយផ្តល់ព័ត៌មានហិរញ្ញវត្ថុពេលជាក់ស្តែងដល់ក្រុមអ្នកគ្រប់គ្រង។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Golden Insurance',
      category: 'ធានារ៉ាប់រង',
      description:
        'ផ្តល់ដំណោះស្រាយគ្រប់គ្រងធានារ៉ាប់រងតាមតម្រូវការ ដែលកាត់បន្ថយពេលដំណើរការបណ្ណធានារ៉ាប់រង ៦០% និងបង្កើនកម្រិតការពេញចិត្តរបស់អតិថិជន ៣៥% ក្នុងរយៈពេល ៦ ខែដំបូង។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Sunrise Hotels',
      category: 'សណ្ឋាគារ',
      description:
        'បានអនុវត្តប្រព័ន្ធ HRMS របស់យើងដើម្បីគ្រប់គ្រងបុគ្គលិកនៅសណ្ឋាគារទាំង ៥ កន្លែង ធ្វើឱ្យការរៀបចំកាលវិភាគកាន់តែប្រសើរ និងកាត់បន្ថយចំណាយរដ្ឋបាល ៣០%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Cambodia Manufacturing Co.',
      category: 'ផលិតកម្ម',
      description:
        'បានដាក់ឱ្យប្រើកញ្ចប់កម្មវិធីអាជីវកម្មពេញលេញរបស់យើង ដើម្បីភ្ជាប់ផែនការផលិតកម្ម ការគ្រប់គ្រងស្តុក និងប្រតិបត្តិការហិរញ្ញវត្ថុ ផលជាប្រសិទ្ធភាពប្រតិបត្តិការកើនឡើង ២៥%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Green Agriculture',
      category: 'កសិកម្ម',
      description:
        'បានអនុវត្តប្រព័ន្ធគ្រប់គ្រងស្តុក និងប្រតិបត្តិការតាមតម្រូវការសម្រាប់អ្នកផ្គត់ផ្គង់កសិកម្មនេះ ជួយពួកគេតាមដានផលិតផលពីចម្ការរហូតដល់អតិថិជន។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
  ],
  cta: {
    title: 'ត្រៀមរួចរាល់ដើម្បីក្លាយជារឿងរ៉ាវជោគជ័យបន្ទាប់របស់យើងហើយឬនៅ?',
    body: 'ទាក់ទងយើងថ្ងៃនេះ ដើម្បីពិភាក្សាពីរបៀបដែលដំណោះស្រាយ AKAS អាចផ្លាស់ប្តូរប្រតិបត្តិការអាជីវកម្មរបស់អ្នក។',
    button: 'ទាក់ទងយើង',
  },
};
